'use client';

import { useQuery } from '@tanstack/react-query';
import { HOUSEHOLD_SUMMARY_KEY } from './queryKeys';
import { getHouseholdSummary } from './views';

export function useHouseholdSummary(enabled = true) {
  return useQuery({
    queryKey: HOUSEHOLD_SUMMARY_KEY,
    queryFn: getHouseholdSummary,
    enabled,
    retry: false,
  });
}
